import React from 'react';
import PropTypes from 'prop-types';
import {
  TabContent, Nav
} from 'reactstrap';

import TabNavItem from './benchmark-tab/TabNavItem';
import TabContentList from './benchmark-tab/TabContentList';

class BenchmarkConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.benchmark.type
    };
  }

  componentDidMount() {
    this.setActiveTab();
  }

  componentDidUpdate(prevState) {
    const { benchmark } = this.props;

    if (benchmark.type !== prevState.benchmark.type)
      this.setActiveTab();
  }

  setActiveTab = () => {
    const { type } = this.props.benchmark;

    if (type)
      this.setState({ activeTab: type });
  }

  toggle = (tab) => {
    const { handleBenchMarkChanged } = this.props;

    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      }, () => handleBenchMarkChanged(tab));
    }
  }

  render() {
    const {
      tabs, benchmark, handleConfigDataChange, metricName, goalError
    } = this.props;
    const { activeTab } = this.state;
    const tabItems = tabs.map(({ name, title }) => (
      <TabNavItem
        key={name}
        toggle={this.toggle}
        activeTab={activeTab}
        name={name}
        title={title}
      />
    ));
    const tabContents = tabs.map(({ name, item, component }, index) => (
      <TabContentList
        key={`${item.name}${index}`}
        goalError={goalError}
        handleConfigDataChange={handleConfigDataChange}
        benchmark={benchmark}
        metricName={metricName}
        item={item}
        name={name}
        component={component}
      />
    ));

    return (
      <div>
        <Nav tabs>
          {tabItems}
        </Nav>
        <TabContent className="benchmark-pane" activeTab={activeTab}>
          {tabContents}
        </TabContent>
      </div>
    );
  }
}

BenchmarkConfig.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
  })),
  handleConfigDataChange: PropTypes.func.isRequired,
  metricName: PropTypes.string.isRequired,
  goalError: PropTypes.string,
  benchmark: PropTypes.shape({
    value: PropTypes.string
  })
};

BenchmarkConfig.defaultProps = {
  goalError: undefined,
  benchmark: {
    value: null
  }
};

export default BenchmarkConfig;



// WEBPACK FOOTER //
// ./src/components/dashboard/BenchMarkConfig.js